import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../api";
import { Row, Col, Button } from 'reactstrap';
import ParadigmaLabeledInput from "../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import ParadigmaAsyncSeeker from "../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"

class Modal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            id: null,
            categoria_id: null,
            nombre:"",
            email:"",
            telefono:"",
            telefono_2:"",
            telefono_3:"",
            direccion:"",
            ciudad:"",
            provincia:"",
            show: false,
            errors: [],
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(['CREATE', 'EDIT', 'DETAIL', 'DELETE']).isRequired,
    }


    resetForm() {
        this.setState({
            id: null,
            categoria_id: null,
            nombre:"",
            email:"",
            telefono:"",
            telefono_2:"",
            telefono_3:"",
            direccion:"",
            ciudad:"",
            provincia:"",
            show: false,
            errors: [],
        });
    }

    getData() {
        return {
            categoria_id: this.state.categoria_id,
            nombre: this.state.nombre, 
            email: this.state.email, 
            telefono: this.state.telefono, 
            telefono_2: this.state.telefono_2, 
            telefono_3: this.state.telefono_3, 
            direccion: this.state.direccion, 
            ciudad: this.state.ciudad, 
            provincia: this.state.provincia, 
            show: this.state.show, 
        };
    }

    setData(data) {
        if (data.success) {
            this.setState({
                nombre : data.nombre,
                categoria_id: data.categoria.id,
                email : data.email,
                telefono : data.telefono,
                telefono_2 : data.telefono_2,
                telefono_3 : data.telefono_3,
                direccion : data.direccion,
                ciudad : data.ciudad,
                provincia : data.provincia,
                show : data.show,
            })
        }
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    modalVars() {
        const { action } = this.props;
        if (action == "CREATE") {
            return {
                get: false,
                submitType: "POST",
                title: "Nuevo Profesional",
                buttonTitle: "Nuevo",
                danger: false,
                buttonIcon: "fa fa-plus fa-lg",
                successMessage: "Profesional ha sido creado con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
            };
        } else if (action == "EDIT") {
            return {
                get: true,
                submitType: "PUT",
                title: "Editar Profesional",
                buttonTitle: "Editar",
                danger: false,
                buttonIcon: "fa fa-pencil fa-lg",
                successMessage: "Profesional ha sido editado con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
                id: this.props.id,
            };
        } else if (action == "DETAIL") {
            return {
                get: true,
                submitType: null,
                title: "Profesional",
                buttonTitle: "Ver",
                danger: false,
                buttonIcon: "fa fa-search fa-lg",
                successMessage: "",
                saveButton: false,
                buttonClass: "",
                disabled: true,
                id: this.props.id,
            };
        } else if (action == "DELETE") {
            return {
                get: true,
                submitType: "DELETE",
                title: "Eliminar Profesional",
                buttonTitle: "Eliminar",
                danger: true,
                buttonIcon: "fa fa-trash fa-lg",
                successMessage: "Profesional ha sido eliminado con éxito.",
                saveButton: true,
                saveButtonLabel: "Eliminar",
                buttonClass: "btn-danger",
                disabled: true,
                id: this.props.id,
            };
        }
    }

    render() {
        let vars = this.modalVars();
        return (
            <ParadigmaModal
                getUrl={(vars.get ? api.profesionales : null)}
                submitUrl={(vars.submitType ? api.profesionales : null)}
                submitType={vars.submitType}
                id={vars.id}
                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => this.props.onSubmit(e)}
                onClose={() => this.resetForm()}
                onPreSubmit={() => this.getData()}

                title={vars.title}

                danger={vars.danger}
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}
                saveButtonLabel={vars.saveButtonLabel}
                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                closeButton={true}
                className="modal-lg"
            >

            <ParadigmaLabeledInput
                md={[2, 10]}
                label={"Categoría"}
                inputComponent={
                    <ParadigmaAsyncSeeker
                        disabled={vars.disabled}
                        onChange={(d) => this.onChangeField("categoria_id", d ? d.id : null)}
                        displayField="nombre"
                        url={api.categorias + "?fields=id,nombre&pageSize=99&sort=nombre"}
                        value={this.state.categoria_id}
                    />
                }
            />

            <ParadigmaLabeledInput
                disabled={vars.disabled}
                md={[2, 10]}
                maxLength={100}
                label={"Nombre"}
                value={this.state.nombre}
                onChange={(e) => this.onChangeField('nombre', e.target.value)}
                error={() => this.getError('nombre')}
            />
            <ParadigmaLabeledInput
                disabled={this.props.action != 'CREATE'}
                md={[2, 10]}
                maxLength={255}
                label={"E-mail"}
                value={this.state.email}
                onChange={(e) => this.onChangeField('email', e.target.value)}
                error={() => this.getError('email')}
            />

            <Row><Col xs={12} className="col-separator my-2 py-1">Teléfonos</Col></Row>

            <ParadigmaLabeledInput
                disabled={vars.disabled}
                md={[2, 10]}
                maxLength={100}
                label={"Teléfono 1"}
                value={this.state.telefono}
                onChange={(e) => this.onChangeField('telefono', e.target.value)}
                error={() => this.getError('telefono')}
            />
            <ParadigmaLabeledInput
                disabled={vars.disabled}
                md={[2, 10]}
                maxLength={255}
                label={"Teléfono 2"}
                value={this.state.telefono_2}
                onChange={(e) => this.onChangeField('telefono_2', e.target.value)}
                error={() => this.getError('telefono_2')}
            />
            <ParadigmaLabeledInput
                disabled={vars.disabled}
                md={[2, 10]}
                maxLength={255}
                label={"Teléfono 3"}
                value={this.state.telefono_3}
                onChange={(e) => this.onChangeField('telefono_3', e.target.value)}
                error={() => this.getError('telefono_3')}
            />

            <Row><Col xs={12} className="col-separator my-2 py-1">Domicilio</Col></Row>

            <ParadigmaLabeledInput
                disabled={vars.disabled}
                md={[2, 10]}
                maxLength={255}
                label={"Dirección"}
                value={this.state.direccion}
                onChange={(e) => this.onChangeField('direccion', e.target.value)}
                error={() => this.getError('direccion')}
            />
            <ParadigmaLabeledInput
                disabled={vars.disabled}
                md={[2, 10]}
                maxLength={255}
                label={"Ciudad"}
                value={this.state.ciudad}
                onChange={(e) => this.onChangeField('ciudad', e.target.value)}
                error={() => this.getError('ciudad')}
            />
            <ParadigmaLabeledInput
                disabled={vars.disabled}
                md={[2, 10]}
                maxLength={255}
                label={"Provincia"}
                value={this.state.provincia}
                onChange={(e) => this.onChangeField('provincia', e.target.value)}
                error={() => this.getError('provincia')}
            />


            <ParadigmaLabeledInput
                md={[2,10]}
                label={"Visible"}
                error={() => this.getError('show')}
                inputComponent={
                    <div className="d-flex">
                        <Button
                            disabled={vars.disabled}
                            className="mr-1 flex-grow-1"
                            color={this.state.show? 'success' : 'secondary'}
                            onClick={() => this.setState({show:true})}
                        >
                            SI
                        </Button>
                        <Button
                            disabled={vars.disabled}
                            className="mr-1 flex-grow-1"
                            color={!this.state.show ? 'danger' : 'secondary'}
                            onClick={() => this.setState({show:false})}
                        >
                            NO
                        </Button>
                    </div>
                }
            />  
            </ParadigmaModal>
        );
    }
}

export default Modal;


// WEBPACK FOOTER //
// ./src/views/Profesionales/Modal.js